// extracted by mini-css-extract-plugin
module.exports = {"ulConteiner":"styles_ulConteiner__20RAx"};